import { render } from "./TestInClass.vue?vue&type=template&id=693c1ff7&scoped=true"
import script from "./TestInClass.vue?vue&type=script&lang=js"
export * from "./TestInClass.vue?vue&type=script&lang=js"

import "./TestInClass.vue?vue&type=style&index=0&id=693c1ff7&scoped=true&lang=css"

import exportComponent from "/var/www/dt_project_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693c1ff7"]])

export default __exports__